"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.acquisitionConfig = void 0;
class acquisitionConfig {
}
exports.acquisitionConfig = acquisitionConfig;
acquisitionConfig.openDocumentTemplate = "<tr id='conf_#: $id #' data-id='conf_#: id #' data-name='#: name #'>"
    + "<td class='confButtons'><div class='btn-group'>"
    + "<button type='button' class='btn btn-default accept'>#: strings.continue #</button>"
    + "<button type='button' class='btn btn-link deny'>#: strings.cancel #</button></div>"
    + "</td>"
    + "<td class='confInstanceIcon'><image src='#: imageUrl #'/></td>"
    + "<td class='confInstance'>#: name #</td>"
    + "<td class='confInstance'>#: cgdocument_lastchangedate #</td>"
    + "</tr>";
acquisitionConfig.openDocumentFields = ["id", "icon", "name", "cgdocument.lastchangedate"];
acquisitionConfig.openDocumentSort = [{ field: "cgdocument_lastchangedate_orig", dir: "desc" }];
